var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-popup",class:{'p-active': _vm.active}},[_c('div',{staticClass:"popup"},[_c('span',{staticClass:"close-icon",on:{"click":function($event){return _vm.deactivePopup()}}}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }